export const SELECT_CASE = "SELECT_CASE"
export const SELECT_REQUEST = "SELECT_REQUEST"
export const SET_SEARCH_STRING = "SET_SEARCH_STRING"
export const SELECT_NO_MORE_ARCHIVED_CASES_TO_FETCH = "SELECT_NO_MORE_ARCHIVED_CASES_TO_FETCH"
export const REQUEST_MINE = "REQUEST_MINE"
export const REQUEST_ALL = "REQUEST_ALL"
export const REQUEST_ARCHIVED = "REQUEST_ARCHIVED"